<template>

  <div>

  <el-row>

    <el-col v-if="showRotate" :span="3" align="left">
      <el-button type="text" icon="fa fa-undo" @click="rotate -=90">&nbsp;Rotate</el-button>
    </el-col>

    <el-col :span="showRotate ? 18 : 24">

  <pdf-toolbar v-if="pageCount" v-model="currentPage" :total-pages="pageCount" />

  </el-col>

    <el-col v-if="showRotate" :span="3" align="right">
      <el-button type="text" @click="rotate +=90">Rotate&nbsp;<i class="fa fa-undo fa-flip-horizontal"></i></el-button>
    </el-col>
  </el-row>


  <!-- PDF goes here -->
  <el-row type="flex" justfy="center">
      <el-col :span="24">

      <pdf
        :src="pdfSrc"
        :rotate="rotate"
        :page="currentPage"
        @num-pages="pageCount = $event"
        @page-loaded="currentPage = $event"
        @link-clicked="currentPage = $event"
        style="width: 100%; height: auto;" />
    </el-col>

  </el-row>

  <pdf-toolbar v-if="showPageNumbersBottom && pageCount" v-model="currentPage" :total-pages="pageCount" />

</div>
</template>

<script>
import pdf from 'vue-pdf'
import PdfToolbar from '@/components/atoms/PdfToolbar'

export default {
  name: 'pdf-viewer',

  components: {
    pdf,
    PdfToolbar
  },

  props: {
    url: {
      type: String,
      required: true
    },

    showRotate: {
      type: Boolean,
      default: true
    },

    showPageNumbersBottom: {
      type: Boolean,
      default: false
    }

  },

  computed: {
    // XOL-144: PDF.js (via vue-pdf) uses CORS-mode XHR internally. Unlike
    // `<img src>` (no-CORS, browser attaches cookies automatically when
    // SameSite=None;Secure), CORS-mode requests default to credentials='omit'
    // — so the xolas_auth cookie is NOT sent and the request 401s. Passing
    // an object src lets us forward `withCredentials: true` to PDF.js's
    // getDocument(), which propagates to the underlying XHR.
    pdfSrc () {
      return {
        url: this.url,
        withCredentials: true
      }
    }
  },

  watch: {
    pageCount: function (val) {
      if (this.currentPage > val) {
        this.currentPage = val
      }
    }
  },

  data () {
    return {
      rotate: 0,
      currentPage: 1,
      pageCount: 0
    }
  }
}

</script>
